import styled from '@emotion/styled';
import { Paper } from '../sharedStyles';

export * from '../sharedStyles';

export const OrderStatusesRow = styled(Paper)`
  display: flex;
  flex-direction: row;
  padding: 0;
`;

export const Status = styled.div`
  background: ${(props) => props.color};
  height: 40px;
  justify-content: center;
  align-items: center;
  display: flex;
  flex: 1;
`;
